<div class="container" [ngClass]="type">
    <span>
        <mat-icon>{{ icon }}</mat-icon>
    </span>
    <span>
        {{ message }}
    </span>
</div>
